<template>
  <UDropdownMenu
    :items="menuItems"
    :content="{ align: 'end', side: 'top' }"
  >
    <button
      type="button"
      aria-haspopup="menu"
      class="flex items-center gap-2 rounded-lg border border-[var(--ui-border)] px-2 py-1.5 text-start transition hover:bg-[var(--ui-bg-elevated)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40"
      :class="collapsed ? 'justify-center' : 'w-full justify-between'"
    >
      <UUser
        :name="collapsed ? undefined : patient.fullName"
        :description="collapsed ? undefined : nationalIdLabel"
        :avatar="avatarProps"
        size="sm"
        :ui="{ root: 'min-w-0' }"
      />
      <UIcon
        v-if="!collapsed"
        name="i-lucide-chevron-down"
        class="size-4 shrink-0 text-[var(--ui-text-muted)]"
      />
    </button>
  </UDropdownMenu>
</template>

<script setup lang="ts">
import type { PatientMemberPublic } from '~/types/patient'
import { toFaDigits } from '~/utils/faDigits'

const props = defineProps<{
  patient: PatientMemberPublic
  collapsed?: boolean
}>()

const emit = defineEmits<{
  logout: []
}>()

const nationalIdLabel = computed(() => {
  const id = props.patient.nationalId?.trim()
  return id ? toFaDigits(id) : 'کد ملی ثبت نشده'
})

const avatarProps = computed(() => ({
  alt: props.patient.fullName,
  icon: 'i-lucide-user',
}))

const menuItems = computed(() => [
  [
    {
      label: 'حساب کاربری',
      icon: 'i-lucide-user-round',
      to: '/patient/profile',
    },
  ],
  [
    {
      label: 'خروج',
      icon: 'i-lucide-log-out',
      color: 'error' as const,
      onSelect: () => emit('logout'),
    },
  ],
])
</script>
